"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadMoreFromConnection = void 0;
exports.getNodes = getNodes;
var typed_primitives_1 = require("@sixfold/typed-primitives");
function getNodes(items) {
    var _a, _b;
    return (_b = (_a = items === null || items === void 0 ? void 0 : items.edges) === null || _a === void 0 ? void 0 : _a.map(function (edge) { return edge === null || edge === void 0 ? void 0 : edge.node; }).filter(typed_primitives_1.notNil)) !== null && _b !== void 0 ? _b : [];
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function path(keys, object) {
    return keys.reduce(function (object, next) {
        if (object === undefined) {
            return undefined;
        }
        return object[next];
    }, object);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setValue(keys, object, value) {
    if (keys.length === 0) {
        return value;
    }
    var result = object ? __assign({}, object) : {};
    result[keys[0]] = setValue(keys.slice(1), object[keys[0]], value);
    return result;
}
var loadMoreFromConnection = function (query, result, connectionKeyPath, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
    var connection;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                connection = path(connectionKeyPath, result.data);
                if (result.data === undefined ||
                    result.fetchMore === undefined ||
                    (0, typed_primitives_1.isNil)(connection) ||
                    (0, typed_primitives_1.isNil)(connection.pageInfo) ||
                    (0, typed_primitives_1.isNil)(connection.pageInfo.hasNextPage) ||
                    !connection.pageInfo.hasNextPage) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, result.fetchMore({
                        query: query,
                        variables: Object.assign({}, result.variables, __assign(__assign({}, (pageSize !== undefined ? { first: pageSize } : {})), { cursor: connection.pageInfo.endCursor })),
                        updateQuery: function (previousResult, _a) {
                            var fetchMoreResult = _a.fetchMoreResult;
                            if (fetchMoreResult === undefined) {
                                return previousResult;
                            }
                            var newConnection = path(connectionKeyPath, fetchMoreResult);
                            if ((0, typed_primitives_1.isNil)(newConnection)) {
                                return previousResult;
                            }
                            var newEdges = newConnection.edges;
                            var pageInfo = newConnection.pageInfo;
                            var result = setValue(connectionKeyPath, fetchMoreResult, __assign(__assign({}, newConnection), { edges: (0, typed_primitives_1.notNil)(newEdges) && (0, typed_primitives_1.notNil)(connection.edges) ? __spreadArray(__spreadArray([], connection.edges, true), newEdges, true) : null, pageInfo: pageInfo }));
                            return result;
                        },
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.loadMoreFromConnection = loadMoreFromConnection;
//# sourceMappingURL=connection.js.map